import { Theme } from '@mui/material';

export function accordion(theme: Theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: '12px',
          margin: '0 !important',
          boxShadow: 'none',

          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
          '&::before': {
            display: 'none',
          },
          '&:first-of-type': {
            borderRadius: '12px',
          },
          '&:last-of-type': {
            borderRadius: '12px',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          height: '56px',
          minHeight: '56px',
          maxHeight: '56px',
          // padding: 0,

          '&.Mui-expanded': {
            minHeight: '56px',
          },

          '&.Mui-disabled': {
            opacity: 1,
            color: theme.palette.action.disabled,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },

          '& .MuiAccordionSummary-content': {
            '& > div': {
              padding: 0,
            },
          },
        },

        content: {
          margin: 0,
        },

        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
